/** Normalize job or raw value to array of qualification labels. */
export function normalizeEducationalQualifications(source) {
  if (!source) return [];
  if (Array.isArray(source)) return source.filter(Boolean);
  if (Array.isArray(source.educationalQualifications) && source.educationalQualifications.length) {
    return source.educationalQualifications.filter(Boolean);
  }
  const single = source.educationalQualification || source;
  if (typeof single === 'string' && single.trim()) {
    const raw = single.trim();
    if (raw.includes(';')) {
      return raw.split(';').map(s => s.trim()).filter(Boolean);
    }
    return [raw];
  }
  return [];
}

export const EDUCATIONAL_QUALIFICATION_OPTIONS = [
  'No Formal Education',
  'Below Matriculation (Class 8th / 9th Pass)',
  'Matriculation / 10th Standard',
  'ITI / Vocational Certificate',
  'Intermediate / Higher Secondary / 12th Standard',
  'Diploma (Polytechnic / Technical)',
  "Graduation / Bachelor's Degree (B.A., B.Sc., B.Com., B.Tech.)",
  'Professional Degree (CA, CS, MBBS, LLB, B.Arch.)',
  'Post-Graduate Diploma / PGDM',
  "Post-Graduation / Master's Degree (M.A., M.Sc., M.Com., M.Tech., MBA)",
  'Integrated / Dual Degree (e.g., B.Tech + M.Tech)',
  'M.Phil (Master of Philosophy)',
  'Doctorate / Ph.D.',
  'Post-Doctoral Fellowship (PDF)',
  'Other / Not Specified'
];

const qualificationIndex = new Map(
  EDUCATIONAL_QUALIFICATION_OPTIONS.map((label, index) => [label.toLowerCase(), index])
);

/** Rank for a canonical qualification label (higher = more advanced). Unknown labels return -1. */
export function qualificationRank(value) {
  const key = String(value || '').trim().toLowerCase();
  if (!key) return -1;
  return qualificationIndex.get(key) ?? -1;
}

export function qualificationLabel(rank) {
  if (rank < 0 || rank >= EDUCATIONAL_QUALIFICATION_OPTIONS.length) return '';
  return EDUCATIONAL_QUALIFICATION_OPTIONS[rank];
}

/** Highest qualification rank from profile (top education level only). */
export function candidateHighestQualificationRank(candidate) {
  let best = qualificationRank(candidate?.educationalQualification);
  for (const row of candidate?.educational || []) {
    const rank = qualificationRank(row?.degree);
    if (rank > best) best = rank;
  }
  return best;
}

export function candidateHighestQualificationLabel(candidate) {
  return qualificationLabel(candidateHighestQualificationRank(candidate));
}

/** Standard qualification levels + any legacy values seen on profiles (for filter dropdowns). */
export function mergeEducationQualificationFilterOptions(facetValues = []) {
  const seen = new Set();
  const out = [];
  for (const label of EDUCATIONAL_QUALIFICATION_OPTIONS) {
    seen.add(label.toLowerCase());
    out.push({ value: label, label });
  }
  for (const v of facetValues || []) {
    const s = String(v).trim();
    if (!s || seen.has(s.toLowerCase())) continue;
    seen.add(s.toLowerCase());
    out.push({ value: s, label: s });
  }
  return out;
}
